import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box } from '@mui/material';
import { shortCode } from './leaveUi';
import { typeTheme, statusPill } from './leaveTheme';
/** The little coloured square with a leave type's short code (EL, CL, …). */
export function CodeTile({ code, size = 34 }) {
    const t = typeTheme(code);
    return (_jsx(Box, { component: "span", "aria-hidden": true, sx: { width: size, height: size, borderRadius: size > 30 ? '8px' : '7px', flexShrink: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            fontSize: size > 30 ? 12 : 11, fontWeight: 700, bgcolor: t.tint, color: t.ink }, children: shortCode(code) }));
}
export function StatusPill({ status }) {
    const s = statusPill(status);
    return (_jsx(Box, { component: "span", sx: { fontSize: { xs: 13, md: 11 }, fontWeight: 600, px: 1.25, py: '3px', borderRadius: 999, bgcolor: s.bg, color: s.ink, whiteSpace: 'nowrap' }, children: s.label }));
}
